<template>
  <div class="rolue_main">
    <div class="closeImg absoluteItem" @click="closeTC">
      <img class="imgBlock noevents-img" src="../../assets/tablegame (4).png" />
    </div>
    <img
      class="imgBlock noevents-img"
      src="../../assets/xiangshui/xiangshui(11).png"
    />
    <div class="rolue_ctr">
      <img
        class="imgBlock noevents-img titrolue absoluteItem"
        src="../../assets/xiangshui/titrolue.png"
      />
      <div class="rimg_main">
        <img
          class="imgBlock noevents-img"
          src="../../assets/xiangshui/rimg01.png"
        />
        <img
          class="imgBlock noevents-img"
          src="../../assets/xiangshui/rimg02.png"
        />
        <img
          class="imgBlock noevents-img"
          src="../../assets/xiangshui/rimg03.png"
        />
      </div>
    </div>

    <img
      class="imgBlock noevents-img"
      src="../../assets/xiangshui/xiangshui(13).png"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    closeTC() {
      this.$emit("faCloseTc");
    },
  },
};
</script>

<style scoped>
.closeImg {
  width: 30px;
  height: 30px;
  right: 20px;
  top: 8%;
}
.rolue_main {
  width: 100%;
  padding-top: 15vh;
  position: relative;
  z-index: 3;
}
.rolue_ctr {
  height: 50vh;
  background: url("../../assets/xiangshui/xiangshui(12).png") repeat;
  background-size: 100% 100%;
  
}
.titrolue {
  top: 20%;
  left: 50%;
  transform: translateX(-50%);
  width: 180px;
  height: 46px;
  margin: 0 auto;
}
.rimg_main {
    position: absolute;
    top: 33%;
    left: 0;
    margin-top: -30px;
    height: 58vh;
    overflow-y: scroll;
}
</style>